import React from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import Images from "../utils/styles/images";

dayjs.extend(utc);
dayjs.extend(timezone);

export const MY_TZ = "Asia/Kuala_Lumpur";

export const INVEST = "INVEST";
export const RETIRE = "RETIRE";

export const YES = "Yes";
export const NO = "No";
export const NRIC = "NRIC";

export const TABS = [
  {
    id: 1,
    name: "Save",
  },
  {
    id: 2,
    name: "Invest",
  },
  {
    id: 3,
    name: "Retirement",
  },
];

export const SAVE_TAB = TABS[0];
export const INVEST_TAB = TABS[1];
export const RETIRE_TAB = TABS[2];

export const DEFAULT = "DEFAULT";

export const customFilterRiskLevelParams = {
  risk_level_1: "risk level 1",
  risk_level_2: "risk level 2",
  risk_level_3: "risk level 3",
  risk_level_4: "risk level 4",
  risk_level_5: "risk level 5",
  risk_level_6: "risk level 6",
  risk_level_7: "risk level 7",
  risk_level_8: "risk level 8",
  all_risk_checked: "all",
  statusName: "Risk level",
};

export const customFilterAssetClassParams = {
  equity: "Equity",
  ltf_rmf: "LTF/RMF",
  money_market: "Money Market",
  fif: "FIF",
  fixed_income: "Fixed Income",
  alternatives: "Alternatives",
  mixed: "Mixed",
  all_checked: "All",
  statusName: "ASSET CLASS",
};
export const customFilterFundStatusParams = {
  active: "Active",
  inactive: "Inactive",
  all_status: "All",
  statusName: "FUND STATUS",
};

export const requestATSData = [
  {
    id: 1,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Approved",
  },
  {
    id: 2,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Approved",
  },
  {
    id: 3,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Approved",
  },
  {
    id: 4,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Pending",
  },
  {
    id: 5,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Reject",
  },
  {
    id: 6,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Approved",
  },
  {
    id: 7,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Approved",
  },
  {
    id: 8,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Reject",
  },
  {
    id: 2,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Approved",
  },
  {
    id: 9,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Approved",
  },
  {
    id: 10,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Approved",
  },
  {
    id: 11,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Approved",
  },
  {
    id: 12,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Approved",
  },
  {
    id: 13,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Approved",
  },
  {
    id: 14,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Approved",
  },
  {
    id: 15,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Approved",
  },
  {
    id: 16,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Approved",
  },
  {
    id: 17,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Approved",
  },
  {
    id: 18,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Approved",
  },
  {
    id: 19,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Approved",
  },
  {
    id: 20,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Approved",
  },
  {
    id: 21,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Approved",
  },
  {
    id: 22,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Approved",
  },
  {
    id: 23,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Approved",
  },
  {
    id: 24,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Approved",
  },
  {
    id: 2,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Approved",
  },
  {
    id: 25,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Approved",
  },
  {
    id: 26,
    unitholder_id: "12349876",
    full_name: "John White",
    bank_name: "CIMB Bank",
    account_no: "1000098765",
    account_name: "CIMB Current Account",
    request_date: "11 Jan  2018",
    status: "Approved",
  },
];

export const CONTENT_BUTTON = {
  REJECTED: {
    PROFILE: (
      <span>
        PROFILE
        <img src={Images.statusIcon.rejected} alt="" />
      </span>
    ),
    DOCUMENT: (
      <span>
        DOCUMENTS
        <img src={Images.statusIcon.rejected} alt="" />
      </span>
    ),
  },
  APPROVED: {
    PROFILE: (
      <span>
        PROFILE
        <img src={Images.statusIcon.approved} alt="" />
      </span>
    ),
    DOCUMENT: (
      <span>
        DOCUMENTS
        <img src={Images.statusIcon.approved} alt="" />
      </span>
    ),
  },
  PENDING: {
    PROFILE: (
      <span>
        PROFILE
        <img src={Images.statusIcon.pending} alt="" />
      </span>
    ),
    DOCUMENT: (
      <span>
        DOCUMENTS
        <img src={Images.statusIcon.pending} alt="" />
      </span>
    ),
  },
};

export const LEAD_CUSTOMER_STATUS = "Lead";

export const TIN_MS_ERROR_MESSAGE =
  "TIN cannot be retrieved at the moment. You can proceed where e-invoice notification will not be applied.";

// Max cash amount allowed (matches DB column customer_portfolio.current_value NUMERIC(18,6))
export const MAX_SWITCH_AMOUNT = 1_000_000_000_000;

export const MIN_SWITCH_AMOUNT = 10;

export const REBATE_FUNDS = ["MYU0100A7208", "MYU0100A7398", "MYU0100A7422"];

export const TITAN_FUNDS = ["MYU0100A6549", "MYU0100A7380", "MYU0100A7422"];

// Rebate promo starts at 31 Aug 2026 00:00:00 Malaysia time (MYT / UTC+8).
// Kept in MYT so the hardcoded date reads exactly as the business requirement.
export const REBATE_PROMO_START_MS = dayjs
  .tz("2026-08-31 00:00:00", MY_TZ)
  .valueOf();

export const REBATE_PROMO_END_MS = dayjs
  .tz("2026-09-30 23:29:59", MY_TZ)
  .valueOf();
export const isRebatePromoActive = () => {
  const now = dayjs()
    .tz(MY_TZ)
    .valueOf();
  return now >= REBATE_PROMO_START_MS && now <= REBATE_PROMO_END_MS;
};

export const RETIREEASY_PROMO_START_MS = dayjs
  .tz("2026-10-12 00:00:00", MY_TZ)
  .valueOf();

export const RETIREEASY_PROMO_END_MS = dayjs
  .tz("2026-11-30 23:29:59", MY_TZ)
  .valueOf();

export const isRetireEasyPromoActive = () => {
  const now = dayjs()
    .tz(MY_TZ)
    .valueOf();
  return now >= RETIREEASY_PROMO_START_MS && now <= RETIREEASY_PROMO_END_MS;
};

export const GOTITAN_PROMO_START_MS = dayjs
  .tz("2026-10-27 00:00:00", MY_TZ)
  .valueOf();

export const GOTITAN_PROMO_END_MS = dayjs
  .tz("2026-11-30 23:59:59", MY_TZ)
  .valueOf();

export const isGotitanPromoActive = () => {
  const now = dayjs()
    .tz(MY_TZ)
    .valueOf();
  return now >= GOTITAN_PROMO_START_MS && now <= GOTITAN_PROMO_END_MS;
};

// Per-surface giveaway banner windows (Malaysia time, inclusive).
// Add / edit a row here when a tab's campaign schedule changes — no code
// changes needed in the tab file itself.
export const GIVEAWAY_SURFACES = Object.freeze({
  INVEST: "invest",
  SAVE: "save",
  RETIRE: "retire",
  GET_STARTED: "getStarted",
});

export const GIVEAWAY_PROMO_WINDOWS = {
  [GIVEAWAY_SURFACES.INVEST]: {
    start: dayjs.tz("2026-10-27 00:00:00", MY_TZ).valueOf(),
    end: dayjs.tz("2026-11-30 23:59:59", MY_TZ).valueOf(),
  },
  [GIVEAWAY_SURFACES.SAVE]: {
    start: dayjs.tz("2026-10-12 00:00:00", MY_TZ).valueOf(),
    end: dayjs.tz("2026-11-30 23:59:59", MY_TZ).valueOf(),
  },
  [GIVEAWAY_SURFACES.RETIRE]: {
    start: dayjs.tz("2026-10-12 00:00:00", MY_TZ).valueOf(),
    end: dayjs.tz("2026-11-30 23:59:59", MY_TZ).valueOf(),
  },
  [GIVEAWAY_SURFACES.GET_STARTED]: {
    start: dayjs.tz("2026-10-12 00:00:00", MY_TZ).valueOf(),
    end: dayjs.tz("2026-11-30 23:59:59", MY_TZ).valueOf(),
  },
};

/**
 * Whether the giveaway banner should be active *right now* on a given
 * surface. Callers must pass a `GIVEAWAY_SURFACES.*` value; unknown
 * surfaces return false so a typo can't accidentally light up a banner
 * in production.
 *
 * @param {typeof GIVEAWAY_SURFACES[keyof typeof GIVEAWAY_SURFACES]} surface
 * @returns {boolean}
 */
export const isGiveawayPromoActive = surface => {
  const window = GIVEAWAY_PROMO_WINDOWS[surface];
  if (!window) return false;
  const now = dayjs()
    .tz(MY_TZ)
    .valueOf();
  return now >= window.start && now <= window.end;
};
